export default "__VITE_ASSET__BIv8VF3s__"